module.exports = __webpack_public_path__ + "img/image-1.3d08f899.jpg";